import React from 'react';
import { AppShell } from '../app-shell';
import LoadingIndicator from '../../components/loading-indicator/loading-indicator';
import { CaseJson } from '../../views/case/case-json/case-json';
import classnames from 'classnames';

import JsonView from '@uiw/react-json-view';
import { nordTheme } from '@uiw/react-json-view/nord';

export class JSONViewApp extends React.Component<
  AppProps.JSONViewAppProps,
  {}
> {
  static defaultProps = {
    activeItem: null,
    loading: true
  };
  hasInlineJson: boolean;
  jsonData: object;

  constructor(props: AppProps.JSONViewAppProps) {
    super(props);
    const searchParams = new URLSearchParams(window.location.search);
    this.hasInlineJson = searchParams.has('hasInlineJson');
    if (this.hasInlineJson) {
      try {
        const raw = sessionStorage.getItem('json_view_data');
        this.jsonData = raw ? JSON.parse(raw) : {};
      } catch {
        this.jsonData = {};
      }
    } else {
      this.jsonData = {};
    }
    this._handleProcessIdChange = this._handleProcessIdChange.bind(this);
  }

  componentDidMount() {
    if (!this.hasInlineJson) this.props.onLoad();
  }

  _handleProcessIdChange(event: React.MouseEvent) {
    event.preventDefault();
    const target =
      (event.target as HTMLDivElement) || document.createElement('div');
    const linkable = target?.closest('a');
    if (!linkable) return;

    const item = linkable.attributes.getNamedItem('data-process-id');
    if (!item) return;

    const processId = parseInt(item.value);
    if (!processId) return;

    if (processId === this.props.activeCaseRun.process_instance_id) return;

    const caseRuns = this.props.activeItem?.caseRuns;

    if (!caseRuns) return;

    const soughtRun = caseRuns.find(
      caseRun => caseRun.process_instance_id === processId
    );

    if (!soughtRun) return;
    this.props.setActiveProcess(soughtRun);
  }

  render() {
    const { props } = this;
    const { loading, locked, activeItem, activeCaseRun } = props;
    const styleClasses = ['centered-application'];
    let inner;
    if (this.hasInlineJson) {
      inner = (
        <JsonView
          value={this.jsonData}
          displayObjectSize={false}
          displayDataTypes={false}
          style={nordTheme}
        />
      );
    } else {
      if (locked) {
        styleClasses.push(`cmx-application-locked`);
      }

      if (loading) {
        styleClasses.push(
          `cmx-application-masked`,
          `cmx-application-loading`,
          'loading-view'
        );
        inner = (
          <div data-testid="loadingIndicator">
            <LoadingIndicator text={`Loading JSON...`} />
          </div>
        );
      } else if (activeItem !== null) {
        styleClasses.push(`cmx-application-loaded`);
        inner = (
          <CaseJson
            caseDetail={activeItem}
            activeCaseRun={activeCaseRun}
            onClick={this._handleProcessIdChange}
          />
        );
      }
    }

    return (
      <AppShell registerActivity={props.registerActivity}>
        <div className={classnames(styleClasses)}>
          {locked && (
            <div className="locked-message">
              The case details you were viewing are no longer active.
            </div>
          )}

          <div className="centered-application-wrapper">{inner}</div>
        </div>
      </AppShell>
    );
  }
}
